// extracted by mini-css-extract-plugin
export default {"container":"SH-z","disabled":"TH-z","bgBlack":"UH-z","content":"VH-z","countdown":"WH-z","topCaption":"XH-z","topHeading":"YH-z","heading":"ZH-z","copy":"_H-z"};